"use client";

import { useTranslation } from "react-i18next";
import CategoryBlock from "./feature-categories/CategoryBlock";
import { categories } from "./feature-categories/data";

const FeatureCategories = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-24 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="font-heading font-bold text-4xl md:text-5xl mb-4">
            {t("features.title")}
            <br />
            <span className="text-gradient">{t("features.titleGradient")}</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t("features.subtitle")}
          </p>
        </div>

        <div className="space-y-24 max-w-6xl mx-auto">
          {categories.map((cat, index) => (
            <CategoryBlock key={cat.id} category={cat} reversed={index % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureCategories;
